import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Loading from '@/components/base/Loading';

interface ProtectedRouteProps {
  children: ReactNode;
  /** Cuando es true, solo el rol superUsuario puede acceder. */
  requireSuper?: boolean;
}

export default function ProtectedRoute({ children, requireSuper = false }: ProtectedRouteProps) {
  const { session, loading, profileLoading, isSuperUsuario } = useAuth();

  if (loading) {
    return <Loading fullScreen label="Verificando sesión..." />;
  }

  if (!session) {
    return <Navigate to="/login" replace />;
  }

  if (requireSuper) {
    if (profileLoading) {
      return <Loading fullScreen label="Verificando permisos..." />;
    }
    if (!isSuperUsuario) {
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}